// components/ActivityInsights/SVGBulletList.js

// components/ActivityInsights/SVGBulletList.js

export default function SVGBulletList({ data, width = 200, height = 50 }) {

  const max = 1; // utilisation is already 0–1
  const barWidth = width / data.length;

 

  return (
    <svg width={width} height={height}>
      {data.map((d, i) => {
        const barHeight = (d.value / max) * height;

        return (
          <rect
            key={i}
            x={i * barWidth}
            y={height - barHeight}
            width={barWidth - 2}
            height={barHeight}
            fill="#00d4ff"
            rx={2}
          />
        );
      })}
    </svg>
  );
}